import { User } from "lucide-react";
import React from "react";
import { getAbbreviation } from "../utils/helpers";

const Profile = () => {
  const userData = JSON.parse(localStorage.getItem("user") || "{}");

 
  const abbrev = getAbbreviation(
    userData.name || userData.email?.split("@")[0]
  );

  return (
    <div className="flex items-center space-x-3">
      <div className="w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-semibold">
        {abbrev}
      </div>
    </div>
  );
};

export default Profile;
